import React from 'react'
import {motion} from 'framer-motion';
import './About.scss'
import { AppWrap,MotionWrap } from '../../wrapper';
import {images} from '../../constants'
// import { urlFor,client } from '../../client';



 const abouts = [
  {
    title:'Dr Maaz Qureshi' , description: 'Prosthodontist' , 
    imgURL: images.DrMaaz
   },
   {
    title:'Dr Rozina' , description: 'Specialist Orthodontist' , imgURL: images.DrRozina
   },
   {
    title:'Dr Shahzad Nasir' , description: 'Oral Surgeon' , imgURL: images.DrShehzad
   },
   {
    title:'Dr Rameez Rizwi' , description: 'Specialist Implantologist' ,imgURL: images.DrRameez 
   },
   {
    title:'Dr Haseeb Alam' , description: 'Specialist Orthodontist' ,imgURL: images.DrHaseeb 
   }

];

const About = () => {

  // const [abouts, setAbouts] = useState([]);
  // useEffect(() => {
  //  const query = '*[_type == "abouts"]';
  //   client.fetch(query)
  //   .then((data)=>setAbouts(data))
  // }, []);
  

  return (
    <>
    <h2 className='head-text'>I have a <span>Good   </span> <br/>
       Professional   <span> Team </span> of Dentists </h2>

      <div className='app__profiles'>
        {abouts.map((about,index)=>(
          <motion.div
            whileInView={{opacity:1}}
            whileHover={{scale:1.1}}
            transition={{duration: 0.5, type:'tween'}}
            className = "app__profile-item"
            key={about.title +index}
          >
            <img src={about.imgURL} alt={about.title}/>
            {/* <img src= {urlFor(about.imgurl)} alt={about.title} /> */}
            <h2 className='bold-text' style={{marginTop:20}}> {about.title} </h2>
            <p className='p-text' style={{marginTop:10}}> {about.description} </p>
          </motion.div>
        ))}
      </div>

    </>
  )
}

export default AppWrap(
  MotionWrap(About,'app__about'),
  'about',"app__whitebg");
  








